import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <p>&copy; 2025 My Web App. All rights reserved.</p>
    
      </div>
    </footer>
  );
};

export default Footer;
